<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Subscriber Data</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Date Type</u></label>
        <select [(ngModel)]="filterable.unsubFlag" class="form-control" placeholder="">
          <option value="false" selected>Subscribe Date</option>
          <option value="true" selected>Unsubscribe Date</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (change)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [value]="country.value">{{country.key}}</option>
        </select>
      </div>

    </div>
    <div class="row mt-3">
      <div class="col">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator" (ngModelChange)="changeOperator($event)">
          <option value=null selected>- select operator-</option>
          <option *ngFor="let op of operatorList | keyvalue" [ngValue]="op.key">{{op.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword">
          <option value=null selected>-select keyword-</option>
          <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Whether is Active</u></label>
        <select [(ngModel)]="filterable.active" class="form-control" placeholder="">
          <option value=null selected>-select active-</option>
          <option value="true" >Active</option>
          <option value="false" >Inactive</option>
        </select>
      </div>
      <div class="col">
          <label for=""><u>Filter by Phone</u></label>
          <input type="text" [(ngModel)]="filterable.phone" class="form-control" placeholder="enter phone" />
      </div>
      <div class="col text-right align-self-end">
          <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
          <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>

  <!-- <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div> -->


</div>
<!-- <div class="table-responsive"> -->
<table id="subscriberList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>ID</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>Phone</th>
      <th>Active</th>
      <th>Subscribe</th>
      <th>Unsubscribe</th>
      <th>Reference</th>
      <th>Last MT</th>
      <th>Last Success MT</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="15">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="15">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let subscriber of subscriberList; index as i;">
      <td>{{subscriber.id}}</td>
      <td>{{subscriber.shortCode}}</td>
      <td>{{subscriber.keyword}}</td>
      <td>{{subscriber.operator}}</td>
      <td>{{subscriber.phone}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Active:</span>&nbsp;
        <span *ngIf="subscriber.active == true" class="text-success text-uppercase font-weight-bold">{{subscriber.active}}</span>
        <span *ngIf="subscriber.active == false" class="text-danger text-uppercase font-weight-bold">{{subscriber.active}}</span>
        <br>
        <span class="font-italic font-weight-bold">Reason:</span> {{subscriber.inactiveMsg}}
      </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">SubMoId:</span> {{subscriber.subscribeMoId}}<br>
        <span class="font-italic font-weight-bold">At:</span> {{subscriber.subscribeAtView}}
      </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">UnsubMoId:</span> {{subscriber.unsubscribeMoId}}<br>
        <span class="font-italic font-weight-bold">At:</span> {{subscriber.unsubscribeAtView}}
      </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">Language:</span>  {{subscriber.lang}} <br>
        <span class="font-italic font-weight-bold">Affiliate:</span>  {{subscriber.affiliate}} <br>
        <span class="font-italic font-weight-bold">ClickId:</span>  {{subscriber.clickId}} <br>
        <span class="font-italic font-weight-bold">Ref:</span>  {{subscriber.reference}} <br>
        <span class="font-italic font-weight-bold">Channel:</span>  {{subscriber.channelView}}
       </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">MtId:</span> {{subscriber.lastMtId}}<br>
        <span class="font-italic font-weight-bold">At:</span> {{subscriber.lastMtAtView}}
      </td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">MtId:</span> {{subscriber.lastChargeId}}<br>
        <span class="font-italic font-weight-bold">At:</span> {{subscriber.lastChargeAtView}}
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="15" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>

